import * as React from "react";
import AnimatedPulse from "../../client/AnimatedPulse/AnimatedPulse";
import EllipseRight from "./Pattern/EllipseRight/EllipseRight";
import EllipseLeft from "./Pattern/EllipseLeft/EllipseLeft";
import EllipseTopLeft from "./Pattern/EllipseTopLeft/EllipseTopLeft";
import PatternContour from "./Pattern/PatternContour/PatternContour";
import PatternContourLeft from "./Pattern/PatternContourLeft/PatternContourLeft";

const BLOCK_TYPES = {
  ANIMATED_PULSE: 'animated_pulse',
  ELLIPSE_RIGHT: 'ellipse_right',
  ELLIPSE_LEFT: 'ellipse_left',
  ELLIPSE_TOP_LEFT: 'ellipse_top_left',
  PATTERN_CONTOUR: 'pattern_contour',
  PATTERN_CONTOUR_LEFT: 'pattern_contour_left',
  BACKGROUND_BLUR: 'background_blur'
} as const;

export const BackgroundAnimated = ({ settings }) => {
  const blocks = settings.blocks || [];

  if (!blocks.length) {
    return null;
  }

  const getResponsiveClasses = (renderType: string) => {
    switch (renderType) {
      case 'mobile-only':
        return 'flex lg:hidden';
      case 'desktop-only':
        return 'hidden lg:flex';
      case 'all':
      default:
        return 'flex';
    }
  };

  const renderBlock = (block) => {
    const blockSettings = block.settings || {};
    const renderType = blockSettings.render_type || 'all';
    
    switch (block.type) {
      case BLOCK_TYPES.ANIMATED_PULSE:
        return (
          <div key={block.id || 'animated-pulse'} className={`w-full ${getResponsiveClasses(renderType)}`}
             style={{ overflowX: 'clip' }}
          > 
            <div className={`relative -z-30`}>
              <AnimatedPulse
                settings={{
                  size: blockSettings.size || 400,
                  delayOffset: blockSettings.delay_offset || 20,
                  count: blockSettings.count || 4,
                  duration: blockSettings.duration || 30,
                  borderWidth: blockSettings.border_width || 1,
                  colors: blockSettings.colors || ["#e3dbc8", "#899B30", "#AC7E4C", "#D6CFF8"],
                  isMultiColor: true
                }}
              />
            </div>
          </div>
        );
      case BLOCK_TYPES.ELLIPSE_RIGHT:
        return (
          <div key={block.id} className={`absolute right-0 -z-30 ${getResponsiveClasses(renderType)}`}>
            <EllipseRight />
          </div>
        );
      case BLOCK_TYPES.ELLIPSE_LEFT:
        return (
          <div key={block.id} className={`absolute left-0 -z-30 ${getResponsiveClasses(renderType)}`}>
            <EllipseLeft />
          </div>
        );
      case BLOCK_TYPES.ELLIPSE_TOP_LEFT:
        return (
          <div key={block.id} className={`absolute -top-36 left-0 -z-30 ${getResponsiveClasses(renderType)}`}>
            <EllipseTopLeft />
          </div>
        );
      case BLOCK_TYPES.PATTERN_CONTOUR:
        return (
          <div key={block.id} className={`absolute right-0 top-4 -z-30 ${getResponsiveClasses(renderType)}`}>
            <PatternContour />
          </div>
        );
      case BLOCK_TYPES.PATTERN_CONTOUR_LEFT:
        return (
          <div key={block.id} className={`absolute left-0 bottom-0 -z-30 ${getResponsiveClasses(renderType)}`}>
            <PatternContourLeft />
          </div>
        );
      case BLOCK_TYPES.BACKGROUND_BLUR:
        return (
          <div key={block.id} className={`relative ${getResponsiveClasses(renderType)}`}
            style={{ overflowX: 'clip' }}
          >
            <div className="background-blur w-[765px] h-[765px] absolute right-0 -z-30"></div>
          </div>
        );
      default:
        return null;
    }
  };

  const validBlocks = blocks.filter(block =>
    Object.values(BLOCK_TYPES).includes(block.type as any)
  );

  if (!validBlocks.length) {
    return null;
  }

  return (
    <>
      {validBlocks.map(renderBlock)}
    </>
  );
};
